import { css } from 'styled-components';
import token from 'styled-token';
import { StyledImage } from '../../components/Image/Image.styles';
import { StyledText } from '../../components/Text/Text.styles';
import { PROPERTY_CARD_APPEARANCES } from '../../constants';
import { spaceMixin } from '../spaceMixin';
import { typographyMixin } from '../typographyMixin';

/** @class PropertyCardMLSFooterMixin */
/** @method */
export var PropertyCardMLSFooterMixin = function PropertyCardMLSFooterMixin(props) {
  return token({
    background: 'PropertyCard.mls.background',
    fontColor: 'PropertyCard.mls.fontColor',
    fontType: "PropertyCard.mls.fontType." + PROPERTY_CARD_APPEARANCES.LARGE,
    fontWeight: 'PropertyCard.mls.footer.text.fontWeight',
    footerPadding: ['PropertyCard.mls.footer.padding'],
    gridColumnTemplate: 'PropertyCard.mls.footer.templateColumns',
    gridGap: 'PropertyCard.mls.footer.gap',
    textPaddingBottom: 'PropertyCard.mls.text.paddingBottom',
    textShadow: 'PropertyCard.mls.textShadow'
  }, function (_ref) {
    var background = _ref.background,
      fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      fontWeight = _ref.fontWeight,
      footerPadding = _ref.footerPadding,
      gridGap = _ref.gridGap,
      _ref$gridColumnTempla = _ref.gridColumnTemplate,
      gridColumnTemplate = _ref$gridColumnTempla === void 0 ? '1fr min-content' : _ref$gridColumnTempla,
      textPaddingBottom = _ref.textPaddingBottom,
      textShadow = _ref.textShadow;
    return css(["align-items:end;background:", ";display:grid;grid-gap:", ";grid-template-columns:", ";padding:", ";", "{", " font-weight:", ";color:", ";padding-bottom:", ";text-shadow:", ";}", "{max-width:none;}"], background, gridGap ? gridGap + "px" : spaceMixin('xs')(props), gridColumnTemplate, footerPadding ? footerPadding.top + "px " + footerPadding.right + "px " + footerPadding.bottom + "px " + footerPadding.left + "px" : spaceMixin('xs')(props) + " " + spaceMixin(0.5)(props) + " " + spaceMixin(0.5)(props) + "\n                " + spaceMixin('xs')(props), StyledText, typographyMixin(Object.assign({
      fontColor: fontColor,
      fontType: fontType
    }, props)), fontWeight, fontColor, textPaddingBottom ? textPaddingBottom + "px" : spaceMixin(0.25)(props), textShadow, StyledImage);
  })(props);
};